(() => {
  'use strict';
 const root=document.querySelector('.gl-living-root');if(!root)return;
  const input = root.querySelector('#collection-search');
  const form = input.closest('form');
  const grid = root.querySelector('.directory > .directory-grid');
  const results = root.querySelector('.search-results');
  const status = root.querySelector('.result-status');
  const clear = root.querySelector('.clear-search');
  const en = document.documentElement.lang === 'en';
  const t = (el, eng) => en ? eng : el;
  const store = location.origin + (en ? '/en-eu' : '');
  let timer, controller, revision = 0;
  const el = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  };
  const searchURL = q => `${store}/search?${new URLSearchParams({q, type: 'product'})}`;
  const itemURL = (type, handle) => `${store}/${type}/${encodeURIComponent(handle)}`;
  function appendArrow(link) {
    const ns = 'http://www.w3.org/2000/svg';
    const icon = document.createElementNS(ns, 'svg');
    for (const [name, value] of Object.entries({width:'1em',height:'1em',viewBox:'0 0 24 24',fill:'none',stroke:'currentColor','stroke-width':'1.5','aria-hidden':'true',focusable:'false'})) icon.setAttribute(name, value);
    icon.style.cssText = 'display:inline-block;width:1em;height:1em;vertical-align:-.12em;flex-shrink:0';
    const path = document.createElementNS(ns, 'path');
    path.setAttribute('d', 'M5 19 19 5M5 5h14v14');
    icon.append(path);
    link.append(' ', icon);
    return link;
  }
  function allResults(q) {
    const a = appendArrow(el('a', 'search-all', t('Όλα τα αποτελέσματα', 'View all results')));
    a.href = searchURL(q);
    return a;
  }
  function imageURL(product) {
    const src = product.images_info?.[0]?.src || Object.values(product.images || {})[0];
    try {
      const url = new URL(src);
      if (url.protocol !== 'https:' || url.hostname !== 'cdn.shopify.com') return null;
      url.searchParams.set('width', '440');
      return url.href;
    } catch { return null; }
  }
  function render(payload, q) {
    results.replaceChildren();
    const allProducts = Array.isArray(payload.products) ? payload.products.slice(0, 10) : [];
    const products = allProducts;
    const collections = Array.isArray(payload.collections) ? payload.collections.slice(0, 3) : [];
    const suggestions = Array.isArray(payload.suggestions) ? payload.suggestions.slice(0, 4) : [];
    const total = Number(payload.total_product) || products.length;
    const updateCount=n=>{status.textContent = total ? t(`${total} προϊόντα · προεπισκόπηση ${n}`, `${total} products · showing ${n}`) : t('Δεν βρέθηκαν προϊόντα. Δοκίμασε άλλη λέξη.', 'No products found. Try another word.');};
    updateCount(Math.min(6,products.length));
    if (suggestions.length || collections.length) {
      const aside = el('aside', 'search-discover');
      if (suggestions.length) {
        aside.append(el('h3', '', t('Δοκίμασε επίσης', 'You might try')));
        const chips = el('div', 'search-chips');
        suggestions.filter(x => typeof x === 'string').forEach(q => {
          const b = el('button', '', q); b.type = 'button';
          b.addEventListener('click', () => {input.value = q; search(true); input.focus();});
          chips.append(b);
        });
        aside.append(chips);
      }
      if (collections.length) {
        aside.append(el('h3', '', t('Συλλογές', 'Collections')));
        collections.filter(x => x.handle && x.title).forEach(c => {
          const a = appendArrow(el('a', 'search-collection', c.title));
          a.href = itemURL('collections', c.handle); aside.append(a);
        });
      }
      results.append(aside);
    }
    const main = el('div', 'search-products-wrap');
    if (products.length) {
      const header = el('div', 'search-products-heading');
      header.append(el('h3', '', t('Προϊόντα', 'Products')), allResults(q));
      main.append(header);
      const cards = el('div', 'search-products');
      products.filter(p => p.handle && p.title).forEach((p,index) => {
        const a = el('a', 'search-product'); a.href = itemURL('products', p.handle);
        a.hidden = index >= 6;
        const visual = el('div', 'search-product-image');
        const src = imageURL(p);
        if (src) {const img = el('img'); img.src = src; img.alt = ''; img.loading = 'lazy'; visual.append(img);}
        a.append(visual, el('h4', '', p.title));
        const price = Number(p.price_min);
        if (Number.isFinite(price)) a.append(el('span', 'search-price', (Number(p.price_max) > price ? t('Από ', 'From ') : '') + new Intl.NumberFormat(en ? 'en-IE' : 'el-GR', {style: 'currency', currency: 'EUR'}).format(price)));
        a.append(el('span', 'search-stock', p.available ? t('Διαθέσιμο', 'Available') : t('Εξαντλήθηκε', 'Sold out')));
        cards.append(a);
      });
      main.append(cards);
      if(products.length>6){
        const more=el('button','search-more',t('Περισσότερα αποτελέσματα','Show more results')+' ↓');more.type='button';
        more.addEventListener('click',()=>{[...cards.children].forEach(card=>card.hidden=false);updateCount(products.length);cards.children[6]?.focus();more.remove();});
        main.append(more);
      }
    } else main.append(allResults(q));
    results.append(main);
  }
  async function fetchResults(q, id) {
    const requestController = new AbortController();
    controller = requestController;
    const timeout = setTimeout(() => requestController.abort(), 9000);
    try {
      const params = new URLSearchParams({shop: 'greenleaf-online-shop.myshopify.com', q, product_limit: '10', collection_limit: '3', suggestion_limit: '4', page_limit: '0', locale: en ? 'en' : 'el'});
      const response = await fetch(`https://services.mybcapps.com/bc-sf-filter/search/suggest?${params}`, {signal: requestController.signal, credentials: 'omit'});
      if (!response.ok) throw new Error('Search unavailable');
      const payload = await response.json();
      if (id !== revision) return;
      if (!payload || !Array.isArray(payload.products)) throw new Error('Invalid response');

      render(payload, q);
    } catch {
      if (id !== revision) return;
      status.textContent = t('Η άμεση αναζήτηση δεν είναι διαθέσιμη αυτή τη στιγμή.', 'Instant search is temporarily unavailable.');
      results.replaceChildren(allResults(q));
    } finally {
      clearTimeout(timeout);
      if (id === revision) results.setAttribute('aria-busy', 'false');
    }
  }
  function search(immediate = false) {
    clearTimeout(timer); controller?.abort();
    const id = ++revision, q = input.value.trim();
    clear.hidden = !q; grid.hidden = !!q; results.hidden = !q;
    results.replaceChildren(); results.setAttribute('aria-busy', 'false');
    status.textContent = '';
    if (!q) return;
    if (q.length < 2) {status.textContent = t('Γράψε τουλάχιστον 2 χαρακτήρες.', 'Type at least 2 characters.'); return;}
    status.textContent = t('Αναζητούμε…', 'Searching…');
    results.setAttribute('aria-busy', 'true');
    timer = setTimeout(() => fetchResults(q, id), immediate ? 0 : 280);
  }
  input.addEventListener('input', () => search());
  clear.addEventListener('click', () => {input.value = ''; search(); input.focus();});
  form.addEventListener('submit', event => {
    event.preventDefault();if(!input.value.trim()){input.focus();return;}location.assign(searchURL(input.value.trim()));
  });
})();
